import { filterTrimValue } from "./on-apply-filters.helper";

export const globalOnSortAction = (
  setPageFunction: (page: number) => void,
  apiCallFunction: (params: any) => void,
  filters: any,
  orderBy: string | null,
  orderType: string | null
) => {
  let {
    orderType: dummyOrderType,
    orderBy: dummyOrderBy,
    ...currentFilter
  } = filters;
  let newFilter = filterTrimValue(currentFilter);
  let params = { ...newFilter, page: 1 };
  if (orderBy && orderType) {
    params = { ...params, orderBy, orderType };
  }
  apiCallFunction(params);
  setPageFunction(1);
};
